import { BROADCAST_SET_MULTIPLE_ATTENDEE_MUTE_STATUSES } from 'actions/Types';

export default muteStatuses => {
  return dispatch => {
    const action = {
      type: BROADCAST_SET_MULTIPLE_ATTENDEE_MUTE_STATUSES,
      payload: muteStatuses
    };
    dispatch(action);
  };
};
